/* function handleSidebarFilter() {
  const filterWrapper = document.getElementById("ombrazFilterWrapper");
  const productGrid = document.querySelector(".ombraz__product-grid");
  if (!filterWrapper) return;

  const filterHeader = filterWrapper.querySelector(".ombraz-filter-header");
  const filterToggle = filterWrapper.querySelector(".ombraz-filter-toggle");
  const sidebar = filterWrapper.querySelector(".ombraz-sidebar");

  function toggleSidebar() {
    if (!sidebar || !filterToggle) return;

    sidebar.classList.toggle("active");
    const isExpanded = sidebar.classList.contains("active");
    filterToggle.setAttribute("aria-expanded", isExpanded.toString());

    // Toggle full-screen class on filterWrapper
    filterWrapper.classList.toggle("is-full-screen", isExpanded);

    // Toggle body scroll
    document.body.style.overflow = isExpanded ? "hidden" : "";

    // Hide/show product grid
    if (productGrid) {
      productGrid.style.visibility = isExpanded ? "hidden" : "visible";
    }

    const icon = filterToggle.querySelector(".ombraz-icon");
    if (icon) {
      icon.classList.toggle("ombraz-icon-chevron-up");
      icon.classList.toggle("ombraz-icon-chevron-down");
    }
  }

  // Close sidebar when clicking outside
  document.addEventListener("click", (e) => {
    if (
      sidebar?.classList.contains("active") &&
      !filterWrapper.contains(e.target) &&
      !e.target.closest("#ombrazFilterToggle")
    ) {
      toggleSidebar();
    }
  });

  // Close sidebar when pressing Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && sidebar?.classList.contains("active")) {
      toggleSidebar();
    }
  });

  // Attach the toggle function to the filter header click event
  if (filterHeader) {
    filterHeader.addEventListener("click", toggleSidebar);
  }

  // Clean up function for removing event listeners
  return () => {
    document.removeEventListener("click", toggleSidebar);
    document.removeEventListener("keydown", toggleSidebar);
    filterHeader?.removeEventListener("click", toggleSidebar);
  };
}

function initializeOnLoad() {
  const isTabletOrMobile = window.matchMedia("(max-width: 1199px)").matches;

  if (isTabletOrMobile) {
    const cleanup = handleSidebarFilter();

    // Clean up event listeners when needed
    window.addEventListener("unload", cleanup);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeOnLoad);
} else {
  initializeOnLoad();
}
 */

function handleSidebarFilter() {
  const filterWrapper = document.getElementById("ombrazFilterWrapper");
  const productGrid = document.querySelector(".ombraz__product-grid");
  if (!filterWrapper) return;

  const filterHeader = filterWrapper.querySelector(".ombraz-filter-header");
  const filterToggle = filterWrapper.querySelector(".ombraz-filter-toggle");
  const sidebar = filterWrapper.querySelector(".ombraz-sidebar");

  const announcementBarHeight = document.querySelector(
    ".ombraz-abtest-announcement"
  ).offsetHeight;
  const stickyHeaderHeight =
    document.querySelector(".sticky-header").offsetHeight;

  if (!stickyHeaderHeight || !announcementBarHeight) return;

  const totalHeight = stickyHeaderHeight + announcementBarHeight;

  // Add CSS for scrollable content
  const style = document.createElement("style");
  style.textContent = `
    .ombraz-filter-wrapper.is-full-screen {
      position: fixed;
      top: ${totalHeight ? `${totalHeight}px` : 0};
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 20;
      background: white;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .ombraz-filter-wrapper.is-full-screen .ombraz-sidebar {
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .ombraz-filter-wrapper.is-full-screen .ombraz-filter-header {
      flex: 0 0 auto;
    }

    body.filter-active {
      overflow: hidden;
      position: fixed;
      width: 100%;
    }
  `;
  document.head.appendChild(style);

  let savedScrollPosition = 0;

  function toggleSidebar() {
    if (!sidebar || !filterToggle) return;

    sidebar.classList.toggle("active");
    const isExpanded = sidebar.classList.contains("active");
    filterToggle.setAttribute("aria-expanded", isExpanded.toString());

    // Toggle full-screen class on filterWrapper
    filterWrapper.classList.toggle("is-full-screen", isExpanded);

    if (isExpanded) {
      // Save scroll position and lock body
      const scrollY = window.scrollY;
      document.documentElement.style.setProperty(
        "--scroll-position",
        `-${scrollY}px`
      );
      document.body.classList.add("filter-active");
    } else {
      // Restore scroll position and unlock body
      const scrollY = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--scroll-position"
        )
      );
      document.body.classList.remove("filter-active");
      document.documentElement.style.removeProperty("--scroll-position");
      window.scrollTo(0, Math.abs(scrollY));
    }

    // Hide/show product grid
    if (productGrid) {
      productGrid.style.visibility = isExpanded ? "hidden" : "visible";
    }

    const icon = filterToggle.querySelector(".ombraz-icon");
    if (icon) {
      icon.classList.toggle("ombraz-icon-chevron-up");
      icon.classList.toggle("ombraz-icon-chevron-down");
    }
  }

  function closeTheFilterHederMobile() {
    const sidebar = document.getElementById("ombrazSidebar");
    const filterWrapper = document.getElementById("ombrazFilterWrapper");
    if (sidebar) {
      sidebar.classList.remove("active");
      if (filterWrapper) {
        filterWrapper.classList.remove("is-full-screen");
      }

      // Remove filter-active class from body
      document.body.classList.remove("filter-active");

      // Restore scroll position
      window.scrollTo(0, savedScrollPosition);

      const productGrid = document.querySelector(".ombraz__product-grid");
      if (productGrid) {
        productGrid.style.visibility = "visible";
      }
    }
  }

  // Prevent scroll propagation to body
  sidebar?.addEventListener(
    "touchmove",
    (e) => {
      e.stopPropagation();
    },
    { passive: true }
  );

  // Close sidebar when clicking outside
  document.addEventListener("click", (e) => {
    if (
      sidebar?.classList.contains("active") &&
      !filterWrapper.contains(e.target) &&
      !e.target.closest("#ombrazFilterToggle")
    ) {
      toggleSidebar();
    }
  });

  // Close sidebar when pressing Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && sidebar?.classList.contains("active")) {
      toggleSidebar();
    }
  });

  // Attach the toggle function to the filter header click event
  if (filterHeader) {
    filterHeader.addEventListener("click", toggleSidebar);
  }

  // Clean up function for removing event listeners
  return () => {
    document.removeEventListener("click", toggleSidebar);
    document.removeEventListener("keydown", toggleSidebar);
    filterHeader?.removeEventListener("click", toggleSidebar);
    sidebar?.removeEventListener("touchmove", (e) => e.stopPropagation());
    document.head.removeChild(style);
  };
}

function initializeOnLoad() {
  const isTabletOrMobile = window.matchMedia("(max-width: 1199px)").matches;

  if (isTabletOrMobile) {
    const cleanup = handleSidebarFilter();

    // Clean up event listeners when needed
    window.addEventListener("unload", cleanup);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeOnLoad);
} else {
  initializeOnLoad();
}
